import React from 'react';
import styled from 'styled-components';

const FindMeTitleStyle = styled.div`
  text-align: center;
  p {
    font-family: var(--font-mono);
    font-size: var(--fs-sm);
    font-weight: 500;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--accent-strong, var(--accent));
    opacity: 0.9;
    margin-bottom: 0.5rem;
  }
  h2 {
    font-family: var(--font-display);
    font-size: var(--fs-display);
    font-weight: 600;
    letter-spacing: -0.01em;
  }
`;

export default function FindMeTitle({
  subheading = 'Need Subheading',
  heading = 'need heading',
}) {
  return (
    <FindMeTitleStyle className="section-title">
      <p>{subheading}</p>
      <h2>{heading}</h2>
    </FindMeTitleStyle>
  );
}
